import React, {Component} from 'react';

class FormContact extends Component {
  constructor(props) {
      super(props);
      this.state = {
          email: '',
          content: '',
          subject: this.props.subject ? this.props.subject: '' ,
          formErrors: {
              email: '',
              subject: '',
              content: ''
          },
          emailValid: false,
          subjectValid: this.props.subject ? true: false,
          contenttValid: false,
          showForm: true,
          formValid: false,
          mailResponse: ''
      }
      this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
      const target = event.target;
      const value = target.value;
      const name = target.name;
      this.setState({
          [name]: value
      }, () => {
          this.validateField(name, value)
      });
  }
  validateForm() {
      this.setState({
          formValid: this.state.emailValid && this.state.subjectValid && this.state.contentValid
      });
  }
  errorClass(error) {
      return (error.length === 0
          ? ''
          : 'has-danger');
  }
  validateField(fieldName, value) {
      let fieldValidationErrors = this.state.formErrors;
      let emailValid = this.state.emailValid;
      let subjectValid = this.state.subjectValid;
      let contentValid = this.state.contentValid;
      switch (fieldName) {
          case 'email':
              emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
              fieldValidationErrors.email = emailValid
                  ? ''
                  : ' is invalid';
              break;
          case 'subject':
              subjectValid = value.trim().length > 0;
              fieldValidationErrors.subject = subjectValid
                  ? ''
                  : ' can not be empty';
              break;
          case 'content':
              contentValid = value.trim().length > 0;
              fieldValidationErrors.content = contentValid
                  ? ''
                  : ' can not be empty';
              break;
          default:
              break;
      }
      this.setState({
          formErrors: fieldValidationErrors,
          emailValid: emailValid,
          subjectValid: subjectValid,
          contentValid: contentValid
      }, this.validateForm);

  }
  render() {
    return (
      <form onSubmit={this.props.onSubmit} encType='application/json'>
          <h3 className="contact-header"
              style={{
              marginBottom: "25px",
              textAlign: "center"
          }}>contact@silverkoppel.com</h3>
          <div className={`form-group row ${this.errorClass(this.state.formErrors.email)}`}>
              <label htmlFor="email" className="col-md-3 col-form-label">Email</label>
              <div className="col-md-9">
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.email}
                    autoComplete="off"
                    name="email"
                    required="required"
                    data-error="Email is required."/>
              </div>
          </div>
          <div className={`form-group row ${this.errorClass(this.state.formErrors.subject)}`}>
              <label htmlFor="subject" className="col-md-3 col-form-label">Subject</label>
              <div className="col-md-9">
                  <input
                    id="subject"
                    type="text"
                    name="subject"
                    onChange={this.handleChange}
                    autoComplete="off"
                    value={this.state.subject}
                    className="form-control"
                    required="required"
                    data-error="Subject is required."/>
              </div>
          </div>
          <div className={`form-group row ${this.errorClass(this.state.formErrors.content)}`}>
              <label htmlFor="content" className="col-md-3 col-form-label">Text</label>
              <div className="col-md-9">
                  <textarea
                    id="content"
                    type="text"
                    name="content"
                    onChange={this.handleChange}
                    value={this.state.content}
                    data-error="Content is required."
                    className="form-control"
                    required="required">
                  </textarea>
              </div>
          </div>
          <div className="text-right">
              <button type="submit" disabled={!this.state.formValid} className="btn btn-default">Send</button>
          </div>
      </form>
    )
  }
}

export default FormContact;



// WEBPACK FOOTER //
// ./src/components/FormContact.js